
import { defineComponent, onBeforeUnmount, reactive, Ref, ref } from 'vue'

import NewHeader from '@/modules/NewDispatcher/components/NewHeader/index.vue'

import Sidebar from '@/common/components/Sidebar/index.vue'
import ImpersonatePanel from '@/common/components/ImpersonatePanel/index.vue'
import TheButton from '@/common/components/UI/TheButton/index.vue'

// composable
import useImpersonate from '@/common/composable/useImpersonate'

// const FIVE_MINUTES = 5 * 60 * 1000

export default defineComponent({
    components: {
        NewHeader,
        sidebar: Sidebar,
        'impersonate-panel': ImpersonatePanel,
        TheButton,
    },
    setup() {
        const state = reactive({
            is_opened: true,
        })
        const { impersonate_state } = useImpersonate(false)
        // const notifications_store = useNotificationsStore()
        // const route = useRoute()
        const interval: Ref<any> = ref(null)

        const toggleSidebar = () => {
            state.is_opened = !state.is_opened
        }

        // const updateNotifications = () => {
        //     if (route.path === '/notifications') {
        //         return
        //     }

        //     notifications_store.loadNotifications({ page: 1 })
        // }

        // onMounted(() => {
        //     updateNotifications()
        //     interval.value = setInterval(updateNotifications, FIVE_MINUTES)
        // })
        onBeforeUnmount(() => {
            if (interval.value !== null) {
                clearInterval(interval.value)
            }
        })

        return { state, impersonate_state, toggleSidebar }
    },
})
